import { displayCorrectContent, getSizeOfUpload, verifyToNotSaveToStorage, verifyToStorage } from "helpers/helpers";
import React, { useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function UploadFile({ setFieldValue, name, value, error, touched, changeText }) {
   const uploadRef = useRef(null);

   const uploadedValue = displayCorrectContent(value);

   const changeTextValue = changeText ? "Încarcă o imagine cu documentul *png, jpg, jpeg" : "Încarcă o fotografie cu documentul *pdf, png, jpg, jpeg";
   const fileUploadType = changeText ? "image/png, image/jpeg, image/jpg" : "application/pdf, image/png, image/jpeg, image/jpg";

   const handleRemoveImage = () => {
      setFieldValue(name, null);
   };

   const reset = () => {
      uploadRef.current.value = "";
   };

   return (
      <>
         <div className="col-md-6 position-relative">
            <label id={name} className="cursor-pointer">
               <input
                  id={name}
                  onChange={async event => {
                     let uploadedFile = event.currentTarget.files[0];

                     const fileSizeInMB = await getSizeOfUpload(uploadedFile);
                     let fileToPersistOrNot = null;
                     if (fileSizeInMB > 1) fileToPersistOrNot = await verifyToNotSaveToStorage(uploadedFile);
                     else fileToPersistOrNot = await verifyToStorage(uploadedFile);

                     setFieldValue(name, fileToPersistOrNot);
                     reset();
                  }}
                  type="file"
                  accept={fileUploadType}
                  className="hidden"
                  ref={uploadRef}
               />
               <img src={require("assets/images/upload.png")} />
            </label>
            <p className="text-up">{changeTextValue}</p>
         </div>

         <div>
            {uploadedValue.imageToDisplay !== null && uploadedValue.imageToDisplay !== undefined && (
               <button type="button" className="delete-button" onClick={() => handleRemoveImage()}>
                  Sterge
               </button>
            )}

            {uploadedValue.isPdf ? (
               <Document file={uploadedValue.imageToDisplay}>
                  <Page pageNumber={1} />
               </Document>
            ) : (
               <img className="ss-prew" src={uploadedValue.imageToDisplay} />
            )}
         </div>

         {error && touched ? <div className="text-center error-msg">{error}</div> : null}
      </>
   );
}
